<template>
  <auth-shell
    welcome="Hoş Geldiniz,"
    title="İzOnay'a Giriş Yapın"
    description="Devam etmek için hesap kodunuzu ve e-posta adresinizi girin."
  >
    <div class="vy-card">
      <form @submit.prevent="getAccount()">
        <fieldset :disabled="loading" class="vy-fieldset">
          <label class="vy-label" for="accountCode">Hesap Kodu</label>
          <div class="vy-field" :class="{ 'vy-field-invalid': codeError }">
            <span class="material-symbols-outlined vy-field-icon">domain</span>
            <input
              ref="accountCode"
              id="accountCode"
              type="text"
              v-model="code"
              @input="checkInput('code', $event)"
              placeholder="Hesap kodunuzu girin"
              autocapitalize="none"
              autocomplete="off"
              required
              aria-describedby="accountCodeHelp"
            />
          </div>
          <div v-if="codeError" id="accountCodeHelp" class="vy-field-error">{{ codeError }}</div>

          <label class="vy-label vy-label-spaced" for="email">E-Posta</label>
          <div class="vy-field">
            <span class="material-symbols-outlined vy-field-icon">mail</span>
            <input
              id="email"
              type="email"
              v-model="email"
              placeholder="E-posta adresinizi girin"
              autocapitalize="none"
              autocomplete="email"
              required
            />
          </div>

          <div class="vy-actions">
            <button type="submit" class="btn vy-btn vy-btn-orange">Devam</button>
          </div>
        </fieldset>
      </form>

      <div v-show="isExternalLoginAvailable" class="vy-external" id="external-logins">
        <div class="vy-divider"><span>veya şununla oturum açın</span></div>
        <LoginWithADFS v-if="isADFSLoginEnabled"></LoginWithADFS>
        <LoginWithMicrosoft v-else></LoginWithMicrosoft>
      </div>
    </div>
  </auth-shell>
</template>
<script>
import axios from "axios";
import LoginWithMicrosoft from '@/components/Login/LoginWithMicrosoft.vue'
import LoginWithADFS from '@/components/Login/LoginWithADFS.vue'
import AuthShell from '@/components/Voya/AuthShell.vue'

export default {
  data() {
    return {
      loading: false,
      code: window.settings.defaultAccountCode ?? "",
      email: "",
      codeError: ""     // Hesap kodu alanı hata metni (< ve > karakterleri)
    };
  },
    components:{
        AuthShell,
        LoginWithMicrosoft,
        LoginWithADFS
    },
  computed: {
        isADFSLoginEnabled(){
            return window.settings.authentication?.adfs?.enabled;
        },
        isAzureLoginEnabled(){
            return window.settings.authentication?.adfs?.enableAzure;
        },
        isExternalLoginAvailable()
        {
            if(!this.isOnPrem || this.isADFSLoginEnabled  || this.isAzureLoginEnabled)
                return true;
            
            return false;
        }
  },
  methods: {
    imgLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return require("../assets/logo.png");
      }
      
    },
    getAccount() {
      if (!this.code) {
        this.$refs.accountCode.focus();
        return;
      }

      this.loading = true;
      axios
        .get("/onpremaccount/get?code=" + this.code)
        .then(x => {
          console.log(x);
          console.log(location)
          let questionMarkIndex = location.href.indexOf('?');
          let newSubstring = `#${this.code}&${this.email}`;
          var url = ""
          if(questionMarkIndex != -1)
            url = "login/" + location.href.slice(questionMarkIndex) + newSubstring
          else
            url = "login/" + newSubstring
          
          if (x.data) {
            location.href = x.data.MobileAppUrl + "&" + this.email;
          } else {
            this.$router.push(url);
          }
        })
        .catch(() => {
          this.$izonayAlert("İşlem gerçekleştirilemedi.");
          this.loading = false;
        });
    },
    handleCodeInput(){
      //console.log(this.code)
      const turkishChars = {
        'Ç': 'C', 'ç': 'c',
        'Ğ': 'G', 'ğ': 'g',
        'İ': 'I', 'ı': 'i',
        'Ö': 'O', 'ö': 'o',
        'Ş': 'S', 'ş': 's',
        'Ü': 'U', 'ü': 'u',
        'I': 'i'  // Special case: Convert capital 'I' to lowercase 'i'
    };

    var data =  this.code.replace(/[\u00C7\u00E7\u011E\u011F\u0130\u0131\u00D6\u00F6\u015E\u015F\u00DC\u00FCI]/g, function(match) {
        return turkishChars[match] || match;
    }).toLowerCase();  // Convert to lowercase
      //var data =  this.code.replace(/I/g, 'i').toLocaleLowerCase('tr')
      this.code = data;
  },
  checkInput() {
      this.handleCodeInput()
      if (/[<>]/.test(this.code)) {
          this.codeError = '< ve > sembolleri kabul edilmemektedir.';
          this.code = "";
      } else {
          this.codeError = "";
      }
    },
  }
};
</script>
